var render = function render(){var _vm=this,_c=_vm._self._c;return _c('article',{staticClass:"swiper-slide"},[_c('section',[_c('div',{staticClass:"card-wrapper"},[_c('router-link',{staticClass:"card-link",attrs:{"to":_vm.linkLocation.replace(/\s+/g, '-').toLowerCase()}},[_c('figure',[_c('font-awesome-icon',{attrs:{"icon":['fas', 'eye']}}),_c('span',{staticClass:"view-all-text"},[_vm._v("View All")])],1)])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }